import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { BlockModalWrapper } from "../../../components/block-modal-wrapper/block-modal-wrapper";
import images from "../../../assets/images";
import useAppStore from "../../../stores/appStore";
import { CustomTypography } from "../../../components/custom-typography/custom-typography";
import { ButtonOutlined } from "../../../components/button-outlined/button-outlined";
import {
  avatarsContainerStyles,
  avatarBoxStyles,
  avatarImageStyles,
  textStyles,
} from "./styles";

const avatars: Array<"Alice" | "Endy" | "Mario" | "Robbi" | "Fatima"> = [
  "Alice",
  "Endy",
  "Mario",
  "Robbi",
  "Fatima",
];

const avatarDisplayNames: Record<
  "Alice" | "Endy" | "Mario" | "Robbi" | "Fatima",
  string
> = {
  Alice: "Alice",
  Endy: "Endy",
  Mario: "Mario",
  Robbi: "Robbi",
  Fatima: "Fatima",
};

export const SettingsAvatarBot: React.FC = () => {
  const { botAvatar, updateBotAvatar } = useAppStore();
  const theme = useTheme();

  const [selectedAvatar, setSelectedAvatar] = useState<
    "Alice" | "Endy" | "Mario" | "Robbi" | "Fatima"
  >(botAvatar || "Robbi");

  const isChanged = selectedAvatar !== botAvatar;

  const handleSelectAvatar = (
    avatar: "Alice" | "Endy" | "Mario" | "Robbi" | "Fatima",
  ) => {
    setSelectedAvatar(avatar);
  };

  const handleSave = () => {
    if (isChanged) {
      updateBotAvatar(selectedAvatar);
    }
  };

  return (
    <BlockModalWrapper lable="Choose your Ai-assistant" isColumn={true}>
      <Box sx={avatarsContainerStyles}>
        {avatars.map((avatar) => (
          <Box
            key={avatar}
            sx={avatarBoxStyles(selectedAvatar === avatar, theme)}
            onClick={() => handleSelectAvatar(avatar)}
          >
            <img
              src={images[avatar]}
              alt={avatar}
              style={{ ...avatarImageStyles, objectFit: "cover" }}
            />
            <CustomTypography sx={textStyles(theme)}>
              {avatarDisplayNames[avatar]}
            </CustomTypography>
          </Box>
        ))}
      </Box>

      <ButtonOutlined
        variant="outlined"
        onClick={handleSave}
        disabled={!isChanged}
      >
        Save
      </ButtonOutlined>
    </BlockModalWrapper>
  );
};

export default SettingsAvatarBot;
